import { render, staticRenderFns } from "./PackIosSignStatus.vue?vue&type=template&id=28a78f4e&"
import script from "./PackIosSignStatus.vue?vue&type=script&lang=js&"
export * from "./PackIosSignStatus.vue?vue&type=script&lang=js&"
import style0 from "./PackIosSignStatus.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports